import React, { Component } from "react";
import { DownloadTableExcel } from "react-export-table-to-excel";
import {
  profile,
  branch,
  alert,
  total,
  float,
  toFixed,
  format_date,
  random_charactor,
  GET,
  POST,
  PUT,
  DELETE,
  loading,
  Status,
  params,
  required,
  DatePicker,
  Select,
  BtnIcon,
  Swal,
  Pagination,
  Switch,
  Navbar,
  Modal,
  Resizer,
} from "../../../components/CustomComponent.js";
import {reports} from "../../../components/Report.js";
export default class SupplierReturn extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter_search: "",
      filter_start_date: format_date(new Date(), "yyyy-mm-dd", "en"),
      filter_end_date: format_date(new Date(), "yyyy-mm-dd", "en"),
      filter_warehouse_id: "",
      filter_payment_type: "",
      filter_status: "รอชำระ,รอสั่งสินค้า,ยกเลิก,คืนสินค้า,ใบแจ้งหนี้,เสร็จสิ้น",

      data: [],
      count: 10,
      data_warehouse: [],

      id: "",
      uid: "",
      bank_name: "",
      account_number: "",
      account_name: "",
    };
    this.tableRef = React.createRef();
  }

  async componentDidMount() {
    loading(false);
    await this.Get(1);
  }
  Get = async (page) => {
    const {
      filter_search,
      filter_start_date,
      filter_end_date,
      filter_warehouse_id,
      filter_payment_type,
      filter_status,
    } = this.state;
    let data, count, data_warehouse;
    loading(true);
    let [result, result_warehouse] = await Promise.all([
      GET("admin/stock-activities/list", {
              page: 0,
        page_size: 10000,
              data_search: filter_search,
              start_date: filter_start_date,
              end_date: filter_end_date,
              warehouse_id: filter_warehouse_id,
              status_code: filter_status,
              type: "คืนสินค้าให้ Sup",
            }),
      GET("admin/setting/warehouses/list", { page: 0, data_search: "" }),
    ]);
    if (result?.status) {
      data = result.data;
      count = result.count;
      let result_product = await Promise.all(
        data.map((e) => GET("admin/stock-activities/list", { uid: e.uid }))
      );
      let array = [];
      for (let item of result_product) {
        array.push({
          ...item.data,
        });
      }

      data = array;
    }
    if (result_warehouse?.status) {
      data_warehouse = result_warehouse.data.map((e) => ({
        value: e.uid,
        label: e.name,
      }));
    }
    this.setState({
      data,
      count,
      data_warehouse,
    });
    loading(false);
  };
  getTableArrayWithSpan = () => {
    const table = this.tableRef.current;
    if (!table) return [];
  
    const rows = Array.from(table.querySelectorAll("tbody tr"));
    const matrix = [];
    const spanMap = {}; // เก็บตำแหน่งที่ถูกจองจาก rowspan
  
    rows.forEach((tr, rowIndex) => {
      matrix[rowIndex] = matrix[rowIndex] || [];
      let colIndex = 0;
  
      // ข้ามช่องที่ถูก rowspan จากแถวก่อน (ใส่ค่าว่าง)
      while (spanMap[`${rowIndex},${colIndex}`]) {
        matrix[rowIndex][colIndex] = "";
        delete spanMap[`${rowIndex},${colIndex}`];
        colIndex++;
      }
  
      Array.from(tr.children).forEach((cell) => {
        const text = cell.innerText.trim();
        const colspan = Number(cell.getAttribute("colspan") || 1);
        const rowspan = Number(cell.getAttribute("rowspan") || 1);
  
        for (let r = 0; r < rowspan; r++) {
          for (let c = 0; c < colspan; c++) {
            const targetRow = rowIndex + r;
            const targetCol = colIndex + c;
  
            matrix[targetRow] = matrix[targetRow] || [];
  
            // ตำแหน่งจริง ใส่ text / ที่เหลือใส่ ""
            matrix[targetRow][targetCol] =
              r === 0 && c === 0 ? text : "*";
  
            // ถ้า rowspan > 1 จองช่องแถวถัดไป
            if (r > 0) {
              spanMap[`${targetRow},${targetCol}`] = true;
            }
          }
        }
  
        colIndex += colspan;
  
        // ข้ามช่องที่ถูกจองไว้
        while (spanMap[`${rowIndex},${colIndex}`]) {
          matrix[rowIndex][colIndex] = "";
          delete spanMap[`${rowIndex},${colIndex}`];
          colIndex++;
        }
      });
    });
  
    return matrix;
  } 
  colSpan = (item, index) => {
    // ช่องนี้เป็นตัวที่โดน merge อยู่แล้ว
    if (item[index] === "*") return 0;
  
    let span = 1;
  
    for (let i = index + 1; i < item.length; i++) {
      if (item[i] === "*") {
        span++;
      } else {
        break;
      }
    }
  
    return span || "";
  };
        ExportPDF = async () => {
          const data_list = this.getTableArrayWithSpan();
        const obj = {
              table: {
                headerRows: 0,
                widths: ["auto","*","auto","auto","auto","auto","auto","auto"],
                body: [
                  [
                    {text: " ", border: [0,0,0,1], fontSize: 2},
                    {text: " ", border: [0,0,0,1], fontSize: 2},
                    {text: " ", border: [0,0,0,1], fontSize: 2},
                    {text: " ", border: [0,0,0,1], fontSize: 2},
                    {text: " ", border: [0,0,0,1], fontSize: 2},
                    {text: " ", border: [0,0,0,1], fontSize: 2},
                    {text: " ", border: [0,0,0,1], fontSize: 2},
                    {text: " ", border: [0,0,0,1], fontSize: 2},
                  ],
                  ...data_list.map((item, index) => {
                    let border = [1, 0, 1, 0];let color = "#ffffff";
                    if(index === data_list.length - 1){
                      border = [1, 0, 1, 1];
                    }
                    if(item[0]){
                      border = !item[0].includes("ลำดับ") ? [1, 0, 1, 0]: [1, 1, 1, 1];
                      color = data_list[index+1].includes("ลำดับ") ? "#d8d8d8": "#ffffff";
                      return [
                          item[0] === "*" ? "" : { text: item[0], alignment: "center", colSpan: this.colSpan(item, 0), fillColor: color, border: [1, border[1], border[2], border[3]] },
                          item[1] === "*" ? "" : { text: item[1], alignment: "left", colSpan: this.colSpan(item, 1), fillColor: color, border },
                          item[2] === "*" ? "" : { text: item[2], alignment: "center", colSpan: this.colSpan(item, 2), fillColor: color, border },
                          item[3] === "*" ? "" : { text: item[3], alignment: "center", colSpan: this.colSpan(item, 3), fillColor: color, border },
                          item[4] === "*" ? "" : { text: item[4], alignment: "center", colSpan: this.colSpan(item, 4), fillColor: color, border },
                          item[5] === "*" ? "" : { text: item[5], alignment: "center", colSpan: this.colSpan(item, 5), fillColor: color, border },
                          item[6] === "*" ? "" : { text: item[6], alignment: "center", colSpan: this.colSpan(item, 6), fillColor: color, border },
                          item[7] === "*" ? "" : { text: item[7], alignment: "right", colSpan: this.colSpan(item, 7), fillColor: color, border: [border[0], border[1], 1, border[3]] },
                        ]
                    }
                    else{
                       border = [1, 1, 1, 1];
                      return [
                        { text: item[6], alignment: "right", colSpan: 7, border },
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        { text: item[7], alignment: "right", border },
                      ]}
                    }
                ),
                ],
              },
            };
        reports("รายงานคืนสินค้าให้ supplier", obj, 14, "portrait");
      }
  render() {
    const {
      modal_detail,
      filter_search,
      filter_start_date,
      filter_end_date,
      filter_warehouse_id,
      filter_payment_type,
      filter_status,
      data,
      count,
      data_warehouse,
      id,
      uid,
      bank_name,
      account_number,
      account_name,
    } = this.state;
    return (
      <div className="w-100 min-vh-100">
        <Navbar />
        <div className="body p-3">
          <div className="rounded-4 bg-white p-3">
            <div className="d-flex justify-content-between">
              <h4 className="fw-bold mb-3 me-3">รายงานคืนสินค้าให้ supplier</h4>
            </div>
            <div className="d-flex align-items-center flex-wrap">
              <input
                type="text"
                className="form-control wpx-200 me-2 mb-2"
                placeholder="บิลขาย, ชื่อลูกค้า, เบอร์โทร..."
                onChange={(e) => {
                  this.setState({ filter_search: e.target.value });
                }}
                onKeyUp={(e) => {
                  if (e.key === "Enter") {
                    this.Get(1);
                  }
                }}
                value={filter_search}
              />
              <input
                type="date"
                className="form-control wpx-200 me-2 mb-2"
                onChange={(e) => {
                  this.setState({ filter_start_date: e.target.value });
                }}
                value={filter_start_date}
              />
              <span className="px-2 me-2 mb-2">ถึง</span>
              <input
                type="date"
                className="form-control wpx-200 me-2 mb-2"
                onChange={(e) => {
                  this.setState({ filter_end_date: e.target.value });
                }}
                value={filter_end_date}
              />
              <select
                className="form-control wpx-200 me-2 mb-2"
                onChange={(e) => {
                  this.setState({ filter_payment_type: e.target.value });
                }}
                value={filter_payment_type}
              >
                <option value="">รูปแบบการชำระเงิน</option>
                <option value="ชำระเงินทันที">ชำระเงินทันที</option>
                <option value="ชำระมัดจำ">ชำระมัดจำ</option>
                <option value="ชำระเงินเชื่อ">ชำระเงินเชื่อ</option>
              </select>
              <select
                className="form-control wpx-200 me-2 mb-2"
                onChange={(e) => {
                  this.setState({ filter_status: e.target.value });
                }}
                value={filter_status}
              >
                <option value="รอชำระ,รอสั่งสินค้า,ยกเลิก,คืนสินค้า,ใบแจ้งหนี้,เสร็จสิ้น">
                  สถานะ
                </option>
                <option value="รอชำระ">รอชำระ</option>
                <option value="รอสั่งสินค้า">รอสั่งสินค้า</option>
                <option value="ยกเลิก">ยกเลิก</option>
                <option value="คืนสินค้า">คืนสินค้า</option>
              </select>
              <div className="wpx-200 me-2 mb-2">
                <Select
                  className="form-control"
                  placeholder="คลังสินค้า..."
                  options={data_warehouse}
                  onChange={(e) => {
                    this.setState({ filter_warehouse_id: e });
                  }}
                  value={filter_warehouse_id}
                />
              </div>
              <div className="d-flex">
                <button
                  className="btn btn-dark px-3 me-2 mb-2"
                  onClick={() => {
                    this.Get(1);
                  }}
                >
                  ค้นหา
                </button>
                <button
                  className="btn btn-outline-dark px-3 me-2 mb-2"
                  onClick={() => {
                    window.location.reload();
                  }}
                >
                  ล้างค่า
                </button>
              </div>
              <div className="ms-auto">
                <button className="btn btn-warning px-3 mb-2 me-2" onClick={()=>this.ExportPDF()}>Export PDF</button>
                <DownloadTableExcel
                  filename="รายการขาย"
                  sheet="รายการขาย"
                  currentTableRef={this.tableRef.current}
                >
                  <button className="btn btn-warning px-3 mb-2">Excel</button>
                </DownloadTableExcel>
              </div>
            </div>
            <div className="table-responsive" style={{maxHeight:"70vh"}}>
              <table
                className="table rounded-3 overflow-hidden table-hover"
                ref={this.tableRef}
              >
                 <tbody>
                                  {data?.filter(item=>!filter_search || JSON.stringify(item?.transaction_list.map(e=>e.product_code + e.product_name)).includes(filter_search)).map((item, index) => (
                                    <>
                                      <tr>
                                        <td className="bg-primary-light text-nowrap"><b>วันที่เอกสาร : </b>
                                          {item.created_at? format_date(item.created_at,"dd/mm/yyyy hh:mm น.")
                                            : ""}
                                        </td>
                                        <td className="bg-primary-light text-nowrap"><b>เลขที่เอกสาร : </b>
                                          {item.document_no}
                                        </td>
                                        <td className="bg-primary-light text-nowrap" colSpan={2}><b>บริษัทจำหน่าย : </b>
                                          {item.supplier?.company_name || "-"}
                                        </td>
                                        <td className="bg-primary-light text-nowrap" colSpan={2}><b>คลังสินค้า : </b>
                                          {item.warehouse?.name || "-"}
                                        </td>
                                        <td className="bg-primary-light text-nowrap text-center"><b>ประเภท : </b>
                                          {item.activity_type || "-"}
                                        </td>
                                        <td className="bg-primary-light text-nowrap text-center"><b>สถานะ : </b>
                                          {item.status || "-"}
                                        </td>
                                      </tr>
                                      <tr>
                                        <td className="text-nowrap">ลำดับ</td>
                    <td className="text-nowrap" colSpan={3}>รหัส/ชื่อสินค้า</td>
                    <td className="text-nowrap">Serial No.</td>
                    <td className="text-nowrap text-center">จำนวน</td>
                    <td className="text-nowrap text-center">ราคา/หน่วย</td>
                    <td className="text-nowrap text-end">มูลค่ารวม</td>
                                      </tr>
                                      {item.transaction_list?.map((item, index) => (
                                        <tr>
                                          <td className="text-nowrap">{index + 1}</td>
                                                                <td className="text-nowrap" colSpan={3}>
                                                                  {item.product_code} {item.product_name}
                                                                </td>
                                                                <td className="text-nowrap">
                                                                  {item.serial_number?.join(", ") || ""}
                                                                </td>
                                                                <td className="text-nowrap">{item.qty}</td>
                                                                <td className="text-nowrap">{item.unit_price}</td>
                                                                <td className="text-nowrap text-end">
                                                                  {toFixed(Number(item.qty) * Number(item.unit_price))}
                                                                </td>
                                        </tr>
                                      ))}
                                      <tr>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td className="fw-bold text-nowrap text-end">
                                          รวมเป็นเงิน
                                        </td>
                                        <td className="fw-bold text-nowrap text-end">
                                          {toFixed(item.amount)}
                                        </td>
                                      </tr>
                                    </>
                                  ))}
                                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
